module.exports = __webpack_public_path__ + "img/slide3.815683a6.png";